import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Toolbar,  
  TextField,
  InputAdornment,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import ProfileTable from './profiles/ProfileTable';
import profilesData from '../data/Profiles.json';
import profileColumns from '../data/ProfileColumns.json';

type Profile = {
  name: string;
  informinterval: number;
  dayskeepstats: number;
  savestats: boolean;
  saveLog: boolean;
  saveParamValues: boolean;
  saveParamValuesInterval: number;
  saveParamValuesOnChange: boolean;
  saveParamValuesOnBoot: boolean;
  scriptname: string;
  baseprofile: string;
  inheritFromParent: boolean;
};

/*const sample: Profile[] = [
  { id: 'p1', name: 'Admin', groups: true, hardware: true, profiles: true, devices: true, userRoles: true },
  { id: 'p2', name: 'Viewer', groups: false, hardware: false, profiles: false, devices: false, userRoles: false },
];*/

const Profiles: React.FC = () => {
  const [query, setQuery] = React.useState('');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  //const [rows, setRows] = React.useState<Profile[]>(() => sample);
    const [rows, setRows] = React.useState<Profile[]>(profilesData);

  /*const columns = [
    { key: 'name', label: 'Profile Name' },
    { key: 'groups', label: 'Groups' },
    { key: 'hardware', label: 'Hardware' },
    { key: 'profiles', label: 'Profiles' },
    { key: 'devices', label: 'Devices' },
    { key: 'userRoles', label: 'UserRoles' },
  ];*/
/*const columns = [
  { key: 'name', label: 'Name' },
  { key: 'informinterval', label: 'Inform Interval' },
  { key: 'dayskeepstats', label: 'Days To Keep Stats' },
  { key: 'savestats', label: 'Save Stats' },
  { key: 'saveLog', label: 'Save Log' },
  { key: 'saveParamValues', label: 'Save Param Values' },
  { key: 'saveParamValuesInterval', label: 'Save Param Values Interval' },
  { key: 'saveParamValuesOnChange', label: 'Save Param Values On Change' },
  { key: 'saveParamValuesOnBoot', label: 'Save Param Values On Boot' },
  { key: 'scriptname', label: 'Script Name' },
  { key: 'baseprofile', label: 'Base Profile' },
  { key: 'inheritFromParent', label: 'Inherit From Parent' },
];*/
const columns = profileColumns;

const emptyProfile: Profile = {
  name: '',
  informinterval: 60,
  dayskeepstats: 1,
  savestats: false,
  saveLog: false,
  saveParamValues: false,
  saveParamValuesInterval: 300,
  saveParamValuesOnChange: false,
  saveParamValuesOnBoot: false,
  scriptname: '',
  baseprofile: '',
  inheritFromParent: false,
};

  const [mode, setMode] = React.useState<'view' | 'new'>('view');
  //const [newProfile, setNewProfile] = React.useState<Profile>({ id: '', name: '', groups: false, hardware: false, profiles: false, devices: false, userRoles: false });
  const [newProfile, setNewProfile] = React.useState<Profile>(emptyProfile);

  const [editOpen, setEditOpen] = React.useState(false);
  const [editProfile, setEditProfile] = React.useState<Profile | null>(null);
  //const [deleteId, setDeleteId] = React.useState<string | null>(null);
  const [deleteName, setDeleteName] = React.useState<string | null>(null);

  const filtered = rows.filter((r) => r.name.toLowerCase().includes(query.toLowerCase()));
  const visible = filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (_: unknown, newPage: number) => setPage(newPage);
  const handleChangeRowsPerPage = (e: React.ChangeEvent<HTMLInputElement>) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); };

  const handleCreate = () => {
    if (!newProfile.name) return;
    //setRows((prev) => [{ ...newProfile, id: String(Date.now()) }, ...prev]);
    setRows((prev) => [newProfile, ...prev]);
    //setNewProfile({ id: '', name: '', groups: false, hardware: false, profiles: false, devices: false, userRoles: false });
    setNewProfile(emptyProfile);
    setMode('view');
  };

  const openEdit = (r: Profile) => { setEditProfile(r); setEditOpen(true); };
  const closeEdit = () => { setEditOpen(false); setEditProfile(null); };
  const handleUpdate = () => {
    if (!editProfile) return;
    setRows((prev) => prev.map((p) => (p.name === editProfile.name ? editProfile : p)));
    closeEdit();
  };

  const openDelete = (name: string) => setDeleteName(name);
  const closeDelete = () => setDeleteName(null);
  const handleConfirmDelete = () => {
    if (!deleteName) return;
    setRows((prev) => prev.filter((r) => r.name !== deleteName));
    closeDelete();
  };

  const textFieldStyle = {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#fff',
      color: '#000',

      '& fieldset': {
        borderColor: '#bdbdbd',
      },

      '&:hover fieldset': {
        borderColor: '#bdbdbd',
      },

      '&.Mui-focused fieldset': {
        borderColor: '#bdbdbd',
      },
    },

    // Input value
    '& .MuiInputBase-input': {
      color: '#000',
    },

    // TextField label
    '& .MuiInputLabel-root': {
      color: '#333 !important',
      backgroundColor: '#fff',
      padding: '0 4px',
    },

    // TextField label when focused
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#000 !important',
    },

    // Placeholder
    '& .MuiInputBase-input::placeholder': {
      color: '#666',
      opacity: 1,
    },
  };


  return (
    <Box sx={{ p: 3, backgroundColor: '#fff',minHeight: '100vh',color: '#000' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h5" sx={{ color: '#000' }}>Profiles</Typography>
        <Button variant="outlined" startIcon={<AddIcon />} onClick={() => setMode('new')}
        sx={{ backgroundColor: '#f5f5f5', color: '#000',borderColor: '#bdbdbd', textTransform: 'none', '& .MuiSvgIcon-root': {color: '#000',},}}>New Profile</Button>
      </Box>

      <Paper sx={{ mb: 1, backgroundColor: 'transparent', boxShadow: 'none' }}>
        <Toolbar sx={{ px: 0, gap: 2, justifyContent: 'space-between' }}>
          <Box />
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <TextField
              placeholder="Enter Profile Name here"
              size="small"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              sx={{width: 450, '& .MuiOutlinedInput-root': {backgroundColor: '#f5f5f5',color: '#000', '& fieldset': {borderColor: '#bdbdbd',},'&:hover fieldset': {borderColor: '#bdbdbd',},'&.Mui-focused fieldset': {borderColor: '#bdbdbd',},},'& .MuiInputBase-input::placeholder': {color: '#000',opacity: 1,},}}
              InputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon sx={{ color: '#666', mr: 1  }} /></InputAdornment>) }}
            />
          </Box>
        </Toolbar>
      </Paper>
      {mode === 'view' ? (
        <Paper sx={{ bgcolor: '#fff', color: '#000', borderRadius: 1, p: 1, mt: 2, boxShadow: 'none' }}>
          <ProfileTable
            columns={columns}
            rows={visible}
            page={page}
            rowsPerPage={rowsPerPage}
            count={filtered.length}
            onEdit={openEdit}
            onDelete={openDelete}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Paper>
      ):(

        <Box sx={{ mt: 2 }}>
          <Typography variant="h5" sx={{ color: '#000', mb: 2 }}>New Profile</Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: '250px 1fr', alignItems: 'center', gap: 2,}}>
            <Typography sx={{ fontWeight: 600, color: '#000' }}>Profile Name :</Typography>
            <TextField placeholder="Enter Profile Name here" value={newProfile.name} onChange={(e) => setNewProfile({ ...newProfile, name: e.target.value })} fullWidth sx={textFieldStyle} />
            <Typography sx={{ fontWeight: 600, color: '#000' }}>Inform Interval :</Typography>
            <TextField type="number" value={newProfile.informinterval} onChange={(e) => setNewProfile({ ...newProfile, informinterval: Number(e.target.value),})} fullWidth sx={textFieldStyle}/>
            <Typography sx={{ fontWeight: 600, color: '#000' }}>Days Keep Stats :</Typography>
            <TextField type="number" value={newProfile.dayskeepstats} onChange={(e) => setNewProfile({ ...newProfile, dayskeepstats: Number(e.target.value),})} fullWidth sx={textFieldStyle}/>
            <Typography sx={{ fontWeight: 600, color: '#000' }}>Save Stats :</Typography>
            <Checkbox checked={newProfile.savestats}  onChange={(e) => setNewProfile({ ...newProfile, savestats: e.target.checked,})} sx={{color: '#555','&.Mui-checked': {color: '#000',},}}/>
            <Typography sx={{ fontWeight: 600, color: '#000' }}> Save Log :</Typography>
            <Checkbox checked={newProfile.saveLog} onChange={(e) => setNewProfile({ ...newProfile, saveLog: e.target.checked,})} sx={{color: '#555','&.Mui-checked': {color: '#000',},}}/>
            <Typography sx={{ fontWeight: 600, color: '#000' }}>Save Parameter Values :</Typography>
            <Checkbox checked={newProfile.saveParamValues} onChange={(e) => setNewProfile({ ...newProfile, saveParamValues: e.target.checked,})} sx={{color: '#555','&.Mui-checked': {color: '#000',},}}/>
            <Typography sx={{ fontWeight: 600, color: '#000' }}>Save Parameter Values Interval :</Typography>
            <TextField type="number" value={newProfile.saveParamValuesInterval} onChange={(e) => setNewProfile({ ...newProfile, saveParamValuesInterval: Number(e.target.value),})}fullWidth sx={textFieldStyle}/>
            <Typography sx={{ fontWeight: 600 }}>Save Parameter Values On Change :</Typography>
            <Checkbox checked={newProfile.saveParamValuesOnChange} onChange={(e) => setNewProfile({ ...newProfile, saveParamValuesOnChange: e.target.checked,})} sx={{color: '#555','&.Mui-checked': {color: '#000',},}}/>
            <Typography sx={{ fontWeight: 600, color: '#000' }}>Save Parameter Values On Boot :</Typography>
            <Checkbox checked={newProfile.saveParamValuesOnBoot} onChange={(e) => setNewProfile({ ...newProfile, saveParamValuesOnBoot: e.target.checked,})} sx={{color: '#555','&.Mui-checked': {color: '#000',},}}/>
            <Typography sx={{ fontWeight: 600, color: '#000' }}>Script Name :</Typography>
            <TextField value={newProfile.scriptname} onChange={(e) => setNewProfile({ ...newProfile, scriptname: e.target.value,})} fullWidth sx={textFieldStyle}/>
            <Typography sx={{ fontWeight: 600, color: '#000' }}>Base Profile :</Typography>
            <TextField value={newProfile.baseprofile} onChange={(e) => setNewProfile({ ...newProfile,baseprofile: e.target.value,})} fullWidth sx={textFieldStyle}/>

            <Typography sx={{ fontWeight: 600, color: '#000' }}>Inherit From Parent :</Typography>
            <Checkbox checked={newProfile.inheritFromParent} onChange={(e) => setNewProfile({ ...newProfile, inheritFromParent: e.target.checked,})} sx={{color: '#555','&.Mui-checked': {color: '#000',},}}/>
            <Box />

            <Box>
              <Button variant="contained" onClick={handleCreate} sx={{ mr: 2, backgroundColor: '#000',color: '#fff',textTransform: 'none','&:hover': {backgroundColor: '#333',}, }}>Create</Button>
              <Button onClick={() => setMode('view')} sx={{color: '#000',textTransform: 'none',}}>Cancel</Button>
            </Box>
          </Box>
        </Box>
      )}

      <Dialog open={editOpen} onClose={closeEdit} fullWidth maxWidth="sm" PaperProps={{sx: {backgroundColor: '#fff',color: '#000',borderRadius: 1,},}}>
          <DialogTitle sx={{backgroundColor: '#fff',color: '#000',fontWeight: 600,}}>Edit Profile</DialogTitle>
          <DialogContent sx={{backgroundColor: '#fff',color: '#000',}}>
            <Box sx={{ display: 'grid', gap: 2, mt: 1 }}>
            <TextField label="Profile Name" placeholder="Enter Profile Name here" value={editProfile?.name ?? ''} onChange={(e) => setEditProfile((p) =>p? {...p,name: e.target.value,}: p)} sx={textFieldStyle}/>
            <TextField label="Inform Interval" type="number" value={editProfile?.informinterval ?? 0} onChange={(e) => setEditProfile((p) => p? { ...p,informinterval: Number(e.target.value),}: p)} sx={textFieldStyle}/>
            <TextField label="Days To Keep Stats" type="number" value={editProfile?.dayskeepstats ?? 0} onChange={(e) => setEditProfile((p) => p ? { ...p, dayskeepstats: Number(e.target.value),}: p)} sx={textFieldStyle}/>x1x1
            <FormControlLabel control={ <Checkbox checked={editProfile?.savestats ?? false} onChange={(e) => setEditProfile((p) => p ? {...p, savestats: e.target.checked,}: p)} sx={{color: '#555','&.Mui-checked': {color: '#000',},}}/>} label="Save Stats"/>
            <FormControlLabel control={ <Checkbox checked={editProfile?.saveLog ?? false} onChange={(e) => setEditProfile((p) => p ? {...p, saveLog: e.target.checked,}: p)} sx={{color: '#555','&.Mui-checked': {color: '#000',},}}/>} label="Save Log"/>
            <FormControlLabel control={ <Checkbox checked={editProfile?.saveParamValues ?? false} onChange={(e) =>setEditProfile((p) => p ? {...p, saveParamValues: e.target.checked,}: p)} sx={{color: '#555','&.Mui-checked': {color: '#000',},}}/>}label="Save Parameter Values"/>
            <TextField label="Save Parameter Values Interval" type="number" value={editProfile?.saveParamValuesInterval ?? 0} onChange={(e) => setEditProfile((p) => p? {...p,saveParamValuesInterval: Number(e.target.value),}: p)} sx={textFieldStyle}/>
            <FormControlLabel control={ <Checkbox checked={editProfile?.saveParamValuesOnChange ?? false} onChange={(e) => setEditProfile((p) => p? {...p, saveParamValuesOnChange: e.target.checked,}: p)}sx={{color: '#555','&.Mui-checked': {color: '#000',},}}/>}label="Save Parameter Values On Change"/>
            <FormControlLabel control={ <Checkbox checked={editProfile?.saveParamValuesOnBoot ?? false} onChange={(e) => setEditProfile((p) => p? {...p, saveParamValuesOnBoot: e.target.checked,}: p)}sx={{color: '#555','&.Mui-checked': {color: '#000',},}}/>}label="Save Parameter Values On Boot"/>
            <TextField label="Script Name" value={editProfile?.scriptname ?? ''} onChange={(e) => setEditProfile((p) => p? {...p, scriptname: e.target.value,}: p)} sx={textFieldStyle}/>
            <TextField label="Base Profile" value={editProfile?.baseprofile ?? ''} onChange={(e) => setEditProfile((p) => p? {...p, baseprofile: e.target.value,}: p)} sx={textFieldStyle}/>
            <FormControlLabel control={ <Checkbox checked={editProfile?.inheritFromParent ?? false} onChange={(e) => setEditProfile((p) => p? {...p, inheritFromParent: e.target.checked,}: p)}sx={{color: '#555','&.Mui-checked': {color: '#000',},}}/>} label="Inherit From Parent"/>
            </Box>
          </DialogContent>

          <DialogActions sx={{backgroundColor: '#fff',padding: '16px 24px',}}>
            <Button onClick={closeEdit} sx={{color: '#000',textTransform: 'none',}}>Cancel</Button>
            <Button variant="contained" onClick={handleUpdate} sx={{backgroundColor: '#000',color: '#fff',textTransform: 'none','&:hover': {backgroundColor: '#333',},}}>Save</Button>
          </DialogActions>
      </Dialog>

      <Dialog open={Boolean(deleteName)} onClose={closeDelete} fullWidth maxWidth="xs" PaperProps={{sx: {backgroundColor: '#fff',color: '#000',borderRadius: 1,},}}>
        <DialogTitle sx={{backgroundColor: '#fff',color: '#000',fontWeight: 600,}}>Confirm Delete</DialogTitle>
        <DialogContent sx={{backgroundColor: '#fff',color: '#333',fontSize: 16,}}>Are you sure you want to delete this profile?</DialogContent>
        <DialogActions sx={{backgroundColor: '#fff',padding: '16px 24px',}}>
          <Button onClick={closeDelete} sx={{color: '#000',textTransform: 'none',}}>Cancel</Button>
          <Button variant="contained" color="error" onClick={handleConfirmDelete}sx={{backgroundColor: '#000',color: '#fff',textTransform: 'none','&:hover': {backgroundColor: '#333',},}}>Delete</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Profiles;
